import { ReactiveComponent } from '~/commons/component/ReactiveComponent'
import { Component, Watch } from '~/commons/component/decorators'

import { lastDateOfMonth, formatDate } from '~/commons/lang/dates'

import { ajax } from '~/services/ajax'

import { MainHeader } from '~/widgets/MainHeader'

import categories from '~/pages/supervisor/categories.json'

@Component({
  components: {
    'main-header': MainHeader,
  },
})
export
class ErpCollectListView extends ReactiveComponent {
  queryWord = ''
  querySupervisor = ''

  queryMonth = ''
  queryFormattedMonth = ''

  queryPageIndex = 1
  queryPageSize = 20

  supervisorOptions = []

  tableData = []

  mounted() {
    this.loadData()
  }

  loadData() {
    this.loadSupervisorOptions()
    this.loadCollectListData()
  }

  @Watch('queryWord')
  @Watch('querySupervisor')
  @Watch('queryFormattedMonth')
  @Watch('queryPageIndex')
  @Watch('queryPageSize')
  loadCollectListData() {
    ajax(
      '/api/receivable',
      {
        method: 'POST',
        body: {
          title: this.queryWord,
          supervisor_id: this.querySupervisor,
          gmt_month: this.queryFormattedMonth,
          page: this.queryPageIndex,
          pageSize: this.queryPageSize,
          per_page: this.queryPageSize,
        },

        assumeJson: true,
      },

      (error, data) => {
        if (error) {
          this.$message({ message: error.message || error, type: 'error' })
        } else {
          this.tableData = data.data
        }
      }
    )
  }

  loadSupervisorOptions() {
    ajax(
      '/api/supervisor_list',
      {
        method: 'GET',
      },
      (error, data) => {
        if (error) {
          this.$message({ message: error.message || error, type: 'error' })
        } else {
          this.supervisorOptions = data
        }
      }
    )
  }

  exportData() {
    ajax(
      '/api/receivable_export',
      {
        method: 'POST',
        body: {
          title: this.queryWord,
          supervisor_id: this.querySupervisor,
          gmt_month: this.queryFormattedMonth,
          page: this.queryPageIndex,
          pageSize: this.queryPageSize,
          per_page: this.queryPageSize,
        },

        assumeJson: true,
      },

      (error, data) => {
        if (error) {
          this.$message({ message: error.message || error, type: 'error' })
        } else {
          this.$message({ message: '导出成功', type: 'success' })
          this.download(data)
        }
      }
    )
  }

  download(url) {
    const anchor = document.createElement('a')

    anchor.download = ''
    anchor.href = url
    document.body.append(anchor)
    anchor.click()
    anchor.remove()
  }

  render() {
    return (
      <section class="erp-collect-page">
        <main-header>
          <span slot="header-title">ERP应收单</span>
        </main-header>

        <section style="margin-top: 20px;">
          <el-row>
            <el-col span={ 3 }>
              <el-input placeholder="关键字查询" value={ this.queryWord } onInput={ e => (this.queryWord = e) } suffix-icon="el-icon-search" clearable />
            </el-col>
            <el-col span={ 3 } offset={ 1 }>
              <el-select placeholder="经销店查询" value={ this.querySupervisor } onInput={ e => (this.querySupervisor = e) } filterable clearable>
                {
                  this.supervisorOptions.map(item => (
                    <el-option label={ item.name } value={ item.id } />
                  ))
                }
              </el-select>
            </el-col>
            <el-col span={ 4 } offset={ 1 }>
              <el-date-picker placeholder="业务日期查询" value={ this.queryMonth } onInput={ e => (this.queryMonth = lastDateOfMonth(e)) } onChange={ e => (this.queryFormattedMonth = e) } type="month" format="yyyy-MM-dd" clearable />
            </el-col>
            <el-col span={ 3 } offset={ 12 - 3 } style="text-align: right;">
              <el-button type="primary" onClick={ e => this.exportData() }>导出应收单</el-button>
            </el-col>
          </el-row>
        </section>

        <section style="margin-top: 20px;" class="erp-collect-main">
          <el-table vLoading_body={ this.loading } data={ this.tableData } border style="width: 100%">
            <el-table-column prop="gmt_month" label="业务日期" />
            <el-table-column prop="end_date" label="到期日" />

            <el-table-column prop="pay_merchant" label="客户 (收款渠道)" />
            {/*<el-table-column prop="divide_type" label="分成类型" />*/}
            <el-table-column prop="company_name" label="结算组织" />
            <el-table-column prop="customer_name" label="收款组织" />
            <el-table-column prop="agent_name" label="代理商" />
            <el-table-column prop="supervisor_name" label="经销点" />

            <el-table-column prop="device_type" label="物料名称" />
            <el-table-column prop="price_qty" label="含税单价" />
            <el-table-column prop="pay_amount" label="付款金额" />
            <el-table-column prop="entry_tax_rate" label="税率/%" />

            <el-table-column label="渠道" scopedSlots={{
              default: scope => (
                categories.find(item => item.value === Number(scope.row.classify))?.label ?? `未知(${scope.row.classify})`
              )
            }}/>
          </el-table>

          <div class="pagination block" style="margin-top: 10px;">
            <el-pagination currentPage={ this.queryPageIndex } pageSize={ this.queryPageSize } layout="total, prev, pager, next, sizes, jumper" onCurrentChange={ e => (this.queryPageIndex = e) } onPrevClick={ e => (this.queryPageIndex = e) } onNextClick={ e => (this.queryPageIndex = e) } onSizeChange={ e => (this.queryPageSize = e) } on-current-change={ e => (this.queryPageIndex = e) } on-size-change={ e => (this.queryPageSize = e) } />
          </div>
        </section>
      </section>
    )
  }
}
